/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import React from 'react';
import { Provider } from 'react-redux';
import createStore from './src/state/createStore';

export const wrapRootComponent = ({ Root }) => {
  return () => (
    <Provider store={createStore()}>
      <Root />
    </Provider>
  );
};



// WEBPACK FOOTER //
// ./gatsby-browser.js